// The platform organisation's credentials (`/api/admin/platform-credentials`, D52, D55), such
// as the default model key task groups fall back to. Reads are metadata only; adding seals the
// value in this browser to the daemon's key for the platform org and signs the request, and
// deleting is signed, both with the Secrets page's helpers.
import { queryOptions } from "@tanstack/react-query";

import { api } from "../api/client";
import { ApiError, unwrap } from "../api/queries";
import { type Signer, sealText, signedBody } from "../secrets/requests";
import { type Credential, createPayload, plaintext, type SecretDraft } from "../secrets/templates";

const PATH = "/api/admin/platform-credentials";

export const platformCredentialsQuery = () =>
  queryOptions({ queryKey: ["platform-credentials"], queryFn: () => unwrap(api.GET(PATH)), retry: false });

export async function addPlatformKey(signer: Signer, orgId: string, draft: SecretDraft, read: (name: string) => string): Promise<Credential> {
  const t = draft.template;
  const sealed = await sealText(signer.proto, orgId, t.kind, plaintext(t.value, read));
  const body = await signedBody(signer, "POST", PATH, createPayload(draft, sealed));
  return unwrap(api.POST(PATH, { body }));
}

export async function deletePlatformKey(signer: Signer, credentialId: string): Promise<void> {
  const body = await signedBody(signer, "DELETE", `${PATH}/${credentialId}`, {});
  let response: Response;
  let error: unknown;
  try {
    ({ response, error } = await api.DELETE("/api/admin/platform-credentials/{credential_id}", {
      params: { path: { credential_id: credentialId } },
      body,
    }));
  } catch (e) {
    throw new ApiError(0, e instanceof Error ? e.message : e);
  }
  if (!response.ok) throw new ApiError(response.status, error);
}
